import { createAction } from 'redux-actions';

export const LOGIN = 'USER/LOGIN';
export const SAVE_USER = 'USER/Save';
export const LOGOUT = 'USER/LOGOUT';
export const MYNUMBER = 'MYNUMBER';
export const RESELLERLOGIN = 'RESELLERLOGIN';



export const saveUser = (user) => ({
  type: SAVE_USER,
  user,
});

export const actionCreators = {
  login: createAction(LOGIN),
  myNumbers: createAction(MYNUMBER),
  resellerLogin: createAction(RESELLERLOGIN),

};
